/**
 * 动态路由配置
 *
 * 每个顶部导航模块独立存放于 routes/ 文件夹，此处按顺序组装。
 *
 * 路由结构：顶部导航 → 左侧菜单 两级结构：
 *   - meta.topNav 标识所属顶部导航标签
 *   - 非 Dashboard 的父级路由使用 RouteView 作为 component（仅提供 <router-view />）
 *   - children 即为左侧菜单项，支持嵌套（最多 2 级侧边栏 + 1 级顶部 = 共 3 级）
 *
 * 每个路由可配置 meta 字段：
 *   - meta.title      菜单/页面标题（硬编码回退）
 *   - meta.titleKey   菜单/页面标题的 i18n key（如 'routes.dashboard'）
 *   - meta.permission 权限 key（可选，无此字段视为公开，用于路由级访问控制）
 *   - meta.icon       图标名称（仅侧边栏叶子节点生效）
 *   - meta.hidden     是否在侧边栏隐藏（默认 false，设为 true 时路由可用但菜单不显示，如详情/编辑页）
 *   - meta.auth       按钮级权限 key 或数组（可选，声明该页面包含的按钮级权限，配合 v-auth 指令使用）
 */

import dashboard from './routes/dashboard';
import products from './routes/products';
import code from './routes/code';
import members from './routes/members';
import marketing from './routes/marketing';
import merchants from './routes/merchants';

export const asyncRoutes = [dashboard, products, code, members, marketing, merchants];
